import httpRequest from "../../ajax";
import {
  CLEAR_JOB_UPDATED,
  DECLINE_APPLICATION,
  ERROR,
  GET_APPLICATION_INSIGHTS,
  GET_APPLICATION_STATS,
  GET_JOB_APPLICANTS,
  GET_BUSINESS_JOB_APPLICANTS,
  GET_JOB_OFFER,
  GET_REFERRAL_STATS,
  GET_REFERRERS,
  UPDATE_APPLICATION,
  HIRE_APPLICANT,
  GET_RECRUITERS_LIST,
  WITHDRAW_APPLICATION,
  LOG_PROFILE_VISITS,
} from "../actionTypes";

export const getMyApplicationInsight = (dispatch) =>
  httpRequest("get", "/insiight/applications/1/10")
    .then(({ data: { data } }) => {
      const action = { type: GET_APPLICATION_INSIGHTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getApplicationStats = (dispatch) =>
  httpRequest("get", "/insiight/applications/stats")
    .then(({ data: { data } }) => {
      const action = { type: GET_APPLICATION_STATS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getReferralStats = (dispatch) =>
  httpRequest("get", "/insiight/referrals/stats")
    .then(({ data: { data } }) => {
      const action = { type: GET_REFERRAL_STATS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getReferrers = (dispatch, page = 1, perPage = 10) =>
  httpRequest("get", `/insiight/referrals/${page}/${perPage}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_REFERRERS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getJobOffersAction = (dispatch, page = 1, limit = 10, search = "") => {
  const params = new URLSearchParams();
  if (search && search.trim() !== "") params.append("search", search.trim());
  const queryString = params.toString() ? `?${params.toString()}` : "";
  return httpRequest("get", `/insiight/jobOffers/${page}/${limit}${queryString}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_JOB_OFFER, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getJobApplicants = (dispatch, id, stage, page = 1, limit = 10, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.search) params.append("search", filters.search);
  if (filters.match_score_min !== undefined && filters.match_score_min !== "") params.append("match_score_min", filters.match_score_min);
  if (filters.match_score_max !== undefined && filters.match_score_max !== "") params.append("match_score_max", filters.match_score_max);
  if (filters.filter_stage !== undefined && filters.filter_stage !== "") params.append("filter_stage", filters.filter_stage);
  if (filters.sort_by) params.append("sort_by", filters.sort_by);
  const queryString = params.toString() ? `?${params.toString()}` : "";

  return httpRequest(
    "get",
    `/insiight/jobOffers/${id}/applicants/${stage}/${page}/${limit}${queryString}`
  )
    .then(({ data: { data } }) => {
      const action = { type: GET_JOB_APPLICANTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const action = { type: GET_JOB_APPLICANTS, payload: [[]] };
      dispatch(action);
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
};

export const getRecruiterJobApplicants = (dispatch, id) =>
  httpRequest("get", `/insiight/jobOffers/${id}/shortlisted/1/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_JOB_APPLICANTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const action = { type: GET_JOB_APPLICANTS, payload: [[]] };
      dispatch(action);
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const updateApplication = (dispatch, data) =>
  httpRequest("post", `/insiight/jobOffers/recieversMoveApplicantAction`, data)
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const moveBusinessApplicant = (dispatch, data) =>
  httpRequest("post", `/insiight/jobOffers/businessMoveApplicantAction`, data)
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const declineApplication = (dispatch, jobId, applicantId) =>
  httpRequest(
    "post",
    `/insiight/jobOffers/${jobId}/applicant/${applicantId}/reject`,
    {}
  )
    .then(({ data: { data } }) => {
      const action = { type: DECLINE_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const clearUpdated = (dispatch) => () => {
  dispatch({
    type: CLEAR_JOB_UPDATED,
  });
};

export const logProfileVisits = (dispatch, id) =>
  httpRequest("post", `/insiight/applications/${id}/profileVisit`)
    .then(({ data: { data } }) => {
      const action = { type: LOG_PROFILE_VISITS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const acceptOrRejectShortlist = (dispatch, data) =>
  httpRequest(
    "post",
    `/recruiter/insight/applicants/acceptOrRejectShortlist`,
    data
  )
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getBusinessJobApplicants = (dispatch, id, company_id, stage) =>
  httpRequest(
    "get",
    `/insiight/jobOffers/${id}/business/applicants/${stage}/${company_id}/1/100`
  )
    .then(({ data: { data } }) => {
      const action = { type: GET_BUSINESS_JOB_APPLICANTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const hireApplicant = (dispatch, data) =>
  httpRequest("post", `/recruiter/insight/applicants/hireApplicant`, data)
    .then(({ data: { data } }) => {
      const action = { type: HIRE_APPLICANT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const hireBusinessApplicant = (dispatch, data) =>
  httpRequest(
    "post",
    `/recruiter/insight/applicants/hireBusinessApplicant`,
    data
  )
    .then(({ data: { data } }) => {
      const action = { type: HIRE_APPLICANT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getRecruitersList = (dispatch, jobId) => {
  httpRequest("get", `/insiight/jobOffers/${jobId}/recruiters/1/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_RECRUITERS_LIST, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const withdrawApplication = (dispatch, jobId, message) =>
  httpRequest("post", `/insiight/applications/${jobId}/wthdraw`, message)
    .then(({ data: { data } }) => {
      const action = { type: WITHDRAW_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const updateApplicantNote = (dispatch, applicantId, note, jobId) =>
  httpRequest("post", `/recruiter/insight/applicant/${applicantId}/note`, { note, job_id: jobId })
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_APPLICATION, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

    export const getApplicantNote = (dispatch, applicantId, jobId) =>
  httpRequest("get", `/recruiter/insight/applicant/${applicantId}/note/${jobId}`)
    .then(({ data }) => {
      return data;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));